import getSocketMiddlewareInstance from '../../common/SocketMiddleware';

export function setEnv(env) {
    return dispatch => {
        return getSocketMiddlewareInstance()
            .setEnv(env)
            .then(environment => {
                dispatch({
                    type: 'TESTBENCH__SET_ENV',
                    environment: environment
                });

                return environment;
            })
            .catch(err => {
                throw err;
            });
    };
}



// WEBPACK FOOTER //
// ./environments/testbench/data/Environments/actions.js